var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateServiceDirectDebt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.356 12.064H1.643L9.541 9.58a24 24 0 0 0 6.267-3.029l3.873-2.625L23.967 6.7a24 24 0 0 0 6.025 2.805l8.364 2.558z",
    fill: "#C9A87A",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.611 15.386v15.38m-24.608-15.38v15.38m-4.614-15.38v15.38m24.608-15.38v15.38M4.62 33.842h30.76M1.543 37.688h36.913M20 18.462h-1.538A1.538 1.538 0 0 0 16.924 20v.577a1.538 1.538 0 0 0 1.107 1.476l3.938 1.15a1.538 1.538 0 0 1 1.107 1.476v1.473a1.538 1.538 0 0 1-1.538 1.538H20m0-9.228h1.538A1.538 1.538 0 0 1 23.076 20v.769M20 18.462v-3.076m0 12.304h-1.538a1.538 1.538 0 0 1-1.538-1.538v-.769M20 27.69v3.076m17.688-19.61v1.154H2.312v-1.154c7.69-2.691 12.305-4.998 17.303-8.844h.77c4.998 3.846 9.612 6.153 17.302 8.844z",
    stroke: "url(#a5k6z5cxja)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a5k6z5cxja",
    x1: 28.934,
    y1: 56.638,
    x2: -8.253,
    y2: 41.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateServiceDirectDebt);
export default __webpack_public_path__ + "static/media/corporateServiceDirectDebt.55de4897290f5959750ea54a28116e9a.svg";
export { ForwardRef as ReactComponent };